/*
    Resource requirements are defined on a service level
    This function checks if the reservation has all the required resources
*/
export var hasRequiredResources = function (service, reservationResources, restaurantSectorId) {
    var _a;
    // We firstly fetch the service requirements for resources
    var assignedResourcesRequirementPerCategory = service === null || service === void 0 ? void 0 : service.assignedResourcesRequirementPerCategory;
    // If there are no requirements, we can return true immediately
    if (!assignedResourcesRequirementPerCategory || Object.keys(assignedResourcesRequirementPerCategory).length === 0)
        return true;
    var _loop_1 = function (resourceCategory, numOfRequiredResources) {
        // Extract resources that match the category
        var resourcesPerCategory = reservationResources === null || reservationResources === void 0 ? void 0 : reservationResources.filter(function (resource) { var _a; return (_a = resource.categoryIds) === null || _a === void 0 ? void 0 : _a.includes(resourceCategory); });
        /* Additional logic that needs to be applied for restaurant sector */
        // If there are some resources with parentId
        for (var _d = 0, _e = resourcesPerCategory; _d < _e.length; _d++) {
            var resource = _e[_d];
            // This determines if the resource is a restaurant (restaurant sector and no parentId)
            var isRestaurant = ((_a = resource.sectorIds) === null || _a === void 0 ? void 0 : _a.includes(restaurantSectorId)) && resource.parentId === undefined;
            if (isRestaurant) {
                // Extract all child resources from reservation
                var childrenResources = reservationResources === null || reservationResources === void 0 ? void 0 : reservationResources.filter(function (r) { return r.parentId; });
                if (!(childrenResources === null || childrenResources === void 0 ? void 0 : childrenResources.length)) {
                    return { value: false };
                }
            }
        }
        // If one of the categories does not have enough resources, return false immediately
        if (((resourcesPerCategory === null || resourcesPerCategory === void 0 ? void 0 : resourcesPerCategory.length) || 0) < (numOfRequiredResources || 0)) {
            return { value: false // This will actually exit the function
             };
        }
    };
    for (var _i = 0, _b = Object.entries(assignedResourcesRequirementPerCategory); _i < _b.length; _i++) {
        var _c = _b[_i], resourceCategory = _c[0], numOfRequiredResources = _c[1];
        var state_1 = _loop_1(resourceCategory, numOfRequiredResources);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    // If no iteration returned false -> it means all categories have enough resources
    return true;
};
export var findPrimaryResourceIdForRes = function (reservation, resources) {
    var _a;
    return (_a = reservation.resourceIds) === null || _a === void 0 ? void 0 : _a.find(function (r) { return resources.some(function (res) { return res.id === r; }); });
};
